module.exports = __webpack_public_path__ + "images/category_lp/hobby/main-view_18511e9d417446b02f69e924d1489d6f.png";